import type { RingCardData } from '@/app/[locale]/_components/HomeRingsModules/_hooks/useRingCardData';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';

const BASE_OR4_CARD_DATA: Omit<
  RingCardData,
  'hrefExplore' | 'hrefShop' | 'includeBgGradient' | 'src'
> = {
  alt: 'pdp_style_oura_ring_4',
  dataCyExplore: 'OR4Explore',
  dataCyShop: 'OR4Shop',
  location: 'lower',
  pdpAction: 'shop or4',
  popAction: 'shop or4',
  showFromPricing: true,
  style: RingStyleEnum.OuraRing4,
  title: 'oura_ring_4',
};

const OR4_CERAMIC_CARD_DATA: RingCardData = {
  alt: 'jade_pdp_midnight_primary_image_alt',
  dataCyExplore: 'OR4CeramicExplore',
  dataCyShop: 'OR4CeramicShop',
  hrefExplore: '/store/rings/oura-ring-4-ceramic',
  hrefShop: '/store/rings/oura-ring-4-ceramic/midnight',
  includeBgGradient: true,
  location: 'lower',
  pdpAction: 'shop or4c',
  popAction: 'shop or4c',
  showFromPricing: false,
  src: '/blue-sky/home/home-ring-module-or4-ceramic.jpg?ar=10:7&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.42&fp-z=2',
  style: RingStyleEnum.Ceramic,
  title: 'oura_ring_4_ceramic',
};

const useRingCardDataMembership = (): RingCardData[] => {
  return [
    {
      ...BASE_OR4_CARD_DATA,
      alt: 'pdp_style_oura_ring_4',
      hrefExplore: '/store/rings',
      hrefShop: '/store/rings/oura-ring-4/silver',
      includeBgGradient: true,
      src: 'blue-sky/home/home-ring-module-or4.jpg?ar=10:7&fit=crop&crop=focalpoint&fp-x=0.55&fp-y=0.36&fp-z=1.9',
    },
    OR4_CERAMIC_CARD_DATA,
  ];
};

export default useRingCardDataMembership;
